/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hidecapacity1Inputs */

const en__field_hidecapacity1 = /** @type {(inputs: _Field_Hidecapacity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide capacity`)
};

const de__field_hidecapacity1 = /** @type {(inputs: _Field_Hidecapacity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapazität verstecken`)
};

/**
* | output |
* | --- |
* | "Hide capacity" |
*
* @param {_Field_Hidecapacity1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_hidecapacity1 = /** @type {((inputs?: _Field_Hidecapacity1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hidecapacity1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_hidecapacity1(inputs)
	return de__field_hidecapacity1(inputs)
});
export { _field_hidecapacity1 as "_field_hideCapacity" }